/**
 *  Init carousel for product-recommendations
 */
const initCarousel = () => {
    const $recommendations = $(".js-product-recommendations");

    if ($recommendations.length > 0) {
        $recommendations.each(function () {
            const $this = $(this);

            $this.slick({
                centerMode: true,
                centerPadding: "12.5%",
                slidesToShow: 3,
                arrows: true,
                infinite: true,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            centerMode: true,
                            slidesToShow: 1,
                            centerPadding: "25%",
                            arrows: false,
                            dots: true
                        }
                    }
                ],
            });
        });
    }
};

initCarousel();
